export class TransportError extends Error {
    kind;
    cause;
    constructor(kind, message, cause) {
        super(message);
        this.kind = kind;
        this.cause = cause;
        this.name = 'TransportError';
    }
}
//# sourceMappingURL=errors.js.map